<template lang="pug">
  .mx-auto.content-box(:class="'md-w-' + width")
    slot
</template>

<script>
export default {
  name: 'Container',
  props: {
    width: { type: String, default: 'xl' }
  }
}
</script>

<style>
</style>
